import { render, staticRenderFns } from "./EditInner.vue?vue&type=template&id=6f49990c&scoped=true&"
import script from "./EditInner.vue?vue&type=script&lang=js&"
export * from "./EditInner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f49990c",
  null
  
)

export default component.exports